import { Play, X } from "lucide-react";
import React from "react";
interface StartInterviewDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    message: string;
}
const StartInterviewDialog = ({ isOpen, onClose, onConfirm, message }: StartInterviewDialogProps) => {
  
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[5000] flex gap-2 items-center justify-center backdrop-blur-sm bg-black/55 ">
      <div className=" p-6 text-sm lg:text-base rounded-lg bg-white dark:bg-gray-900 shadow-lg w-72 xs:w-[400px]">
        <h2 className="text-lg font-semibold dark:text-slate-200 text-gray-800">Starting interview Session</h2>
        <p className="text-gray-600 dark:text-slate-300 mt-2">{message}</p>
        <div className="mt-4 flex justify-center space-x-2">
          <button
          onClick={onConfirm}
            className="px-2 lg:px-2  py-1 lg:py-2  flex items-center gap-1 bg-accent-500/95 text-slate-50 hover:bg-accent-500  rounded-md "
            >
            <Play /> Start <span className="hidden md:inline">Interview</span>
          </button>
          <button
            onClick={onClose}
            className="px-2 lg:px-4 flex items-center gap-1 py-1 lg:py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
          >
          <X />  Cancel  <span className="hidden md:inline">Interview</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default StartInterviewDialog;
